import React, { useState, useEffect } from 'react'
import { Dropdown } from 'primereact/dropdown'
import { InputText } from 'primereact/inputtext'

const discountOptions = [
  { label: 'Flat', value: 'flat' },
  { label: 'Percentage', value: 'percentage' }
]

export default function Discount({ form, handleChange }) {
  const [errors, setErrors] = useState({
    minPurchase: '',
    maxCap: ''
  });

  
  // useEffect(() => {
  //   const newErrors = {};

   
  //   if (form.discount.minPurchase && isNaN(form.discount.minPurchase)) {
  //     newErrors.minPurchase = 'Min purchase must be a number';
  //   } else if (form.discount.minPurchase < 0) {
  //     newErrors.minPurchase = 'Min purchase must be positive';
  //   }

  //   // Validate maxCap if percentage
  //   if (form.discount.discountType === 'percentage') {
  //     if (form.discount.maxCap && isNaN(form.discount.maxCap)) {
  //       newErrors.maxCap = 'Max cap must be a number';
  //     } else if (form.discount.maxCap < 0) {
  //       newErrors.maxCap = 'Max cap must be positive';
  //     }

  //     // Check logic: min > maxCap
  //     if (
  //       form.discount.minPurchase &&
  //       form.discount.maxCap &&
  //       Number(form.discount.minPurchase) > Number(form.discount.maxCap)
  //     ) {
  //       newErrors.maxCap = 'Max cap should be >= min purchase';
  //     }
  //   }

  //   setErrors(newErrors);
  // }, [form.discount]);

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h4 className="text-xl font-semibold mb-4 whitespace-nowrap">Discount</h4>
      <div className="flex flex-col gap-4">

        {/* Discount Type */}
        <div className="flex flex-col">
          <label className="mb-2 font-medium text-gray-700">Discount Type</label>
          <Dropdown
            value={form.discount.discountType}
            options={discountOptions}
            onChange={(e) => handleChange('discount.discountType', e.value)}
            placeholder="Select Type"
            className="w-full border border-gray-300 rounded"
          />
        </div>

        {/* Discount Value */}
        {form.discount.discountType === 'flat' && (
          <div className="flex flex-col">
            <label className="mb-2 font-medium text-gray-700">Flat Discount Value (₹)</label>
            <InputText
              value={form.discount.discountValue || ''}
              onChange={(e) => handleChange('discount.discountValue', e.target.value)}
              placeholder="Enter flat discount"
              className="w-full border border-gray-300 rounded p-2"
            />
          </div>
        )}

        {form.discount.discountType === 'percentage' && (
          <div className="flex flex-col">
            <label className="mb-2 font-medium text-gray-700">Discount %</label>
            <InputText
              value={form.discount.discountValue || ''}
              onChange={(e) => handleChange('discount.discountValue', e.target.value)}
              placeholder="Enter %"
              className="mb-3 border border-gray-300 rounded p-2"
            />

            <label className="mb-2 font-medium text-gray-700">Max Discount Cap (₹)</label>
            <InputText
              value={form.discount.maxCap || ''}
              onChange={(e) => handleChange('discount.maxCap', e.target.value)}
              placeholder="Enter max ₹ cap"
              className="border border-gray-300 rounded p-2"
            />
            {errors.maxCap && (
              <small className="text-red-500 mt-1">{errors.maxCap}</small>
            )}
          </div>
        )}

        {/* Min Purchase Amount (common) */}
        <div className="flex flex-col">
          <label className="mb-2 font-medium text-gray-700">Min Purchase Amount (₹)</label>
          <InputText
            value={form.discount.minPurchase || ''}
            onChange={(e) => handleChange('discount.minPurchase', e.target.value)}
            placeholder="Enter min cart value"
            className="border border-gray-300 rounded p-2"
          />
          {errors.minPurchase && (
            <small className="text-red-500 mt-1">{errors.minPurchase}</small>
          )}
        </div>
      </div>
    </div>
  );
}
